module.exports = {
  zero: '0px',
  xxs: '375px',
  xs: '480px',
  s: '520px',
  sm: '640px',
  m: '768px',
  lm: '980px',
  l: '1024px',
  xl: '1280px'
};
